import { useEffect, useState } from "react";
import {
  interestFormType,
  groupMeLinkType,
  instagramLinkType,
  spotifyLinkType,
} from "../../../firebase/models"; // adjust path as needed
import { fetchSocialLink } from "../../../firebase/FirebaseFunctions"; // adjust path

type SocialLinksData = {
  interestFormLinks: interestFormType[];
  groupMeLinks: groupMeLinkType[];
  instagramLinks: instagramLinkType[];
  spotifyLinks: spotifyLinkType[];
  loading: boolean;
  error: string | null;
};

export const useSocialLinks = (): SocialLinksData => {
  const [interestFormLinks, setInterestFormLinks] = useState<
    interestFormType[]
  >([]);
  const [groupMeLinks, setGroupMeLinks] = useState<groupMeLinkType[]>([]);
  const [instagramLinks, setInstagramLinks] = useState<instagramLinkType[]>([]);
  const [spotifyLinks, setSpotifyLinks] = useState<spotifyLinkType[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const loadAllLinks = async () => {
      try {
        const [
          fetchedInterest,
          fetchedGroupMe,
          fetchedInstagram,
          fetchedSpotify,
        ] = await Promise.all([
          fetchSocialLink<interestFormType>("googleForm"),
          fetchSocialLink<groupMeLinkType>("groupMe"),
          fetchSocialLink<instagramLinkType>("instagram"),
          fetchSocialLink<spotifyLinkType>("spotify"),
        ]);

        setInterestFormLinks(fetchedInterest);
        setGroupMeLinks(fetchedGroupMe);
        setInstagramLinks(fetchedInstagram);
        setSpotifyLinks(fetchedSpotify);
      } catch (err) {
        setError("Failed to load one or more social links.");
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    loadAllLinks();
  }, []);

  return {
    interestFormLinks,
    groupMeLinks,
    instagramLinks,
    spotifyLinks,
    loading,
    error,
  };
};
